import { useTheme } from './useTheme.js';
import { u as useWindowSizeStore } from '../providers/windowSizeContext/windowSizeContext.js';

function useResponsiveConditional(breakpoint) {
  var _useWindowSizeStore = useWindowSizeStore(function (store) {
      return store.width;
    }),
    windowWidth = _useWindowSizeStore.state;
  var _useTheme = useTheme(),
    themeBreakpoints = _useTheme.base.breakpoint;
  return windowWidth !== null && windowWidth >= themeBreakpoints[breakpoint];
}

export { useResponsiveConditional };
//# sourceMappingURL=useResponsiveConditional.js.map
